import { createSelector } from '@ngrx/store'
import { selectFeatures } from '../../features.selectors'
import { FeaturesState } from '../../features.state'
import { adapter } from './organization.reducer'

export const selectOrganizationState = createSelector(
  selectFeatures,
  (state: FeaturesState) => state.organizations
)
export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors(selectOrganizationState)

export const getOganizationById = (id: string) =>
  createSelector(selectEntities, (entities) => entities[id])
